module.exports = __webpack_public_path__ + "static/media/tim.e30aa0e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wav/tim.mp3
// module id = p0H6
// module chunks = 1